module.exports = __webpack_public_path__ + "img/tile-vignettes.6560b723.png";